(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeFieldDetailController', ChangeFieldDetailController);

    ChangeFieldDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ChangeField'];

    function ChangeFieldDetailController($scope, $rootScope, $stateParams, entity, ChangeField) {
        var vm = this;
        vm.changeField = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:changeFieldUpdate', function(event, result) {
            vm.changeField = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
